import React from 'react';
import Framework from "@beardeddevops/react.framework";
import {Collections} from "components";

const breadcrumbStatic = [{
	name: 'Freshdesk Merge Filters',
	url: '/admins/freshdesk_merge_subjects',
	icon: 'dashboard'
}];

export default class Freshdesk_Merge_Subjects extends Framework.Components.View {

	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbStatic} history={this.props.history}/>
				<Collections.FreshdeskMergeSubjects/>
			</div>
		);
	}
}
